import React, { Component } from 'react'
import { connect } from 'react-redux'
import 'react-image-gallery/styles/css/image-gallery.css'
import ImageGallery from 'react-image-gallery'
import Markdown from 'react-markdown'
import SectionTitle from '../../shared/components/SectionTitle'

import styles from './styles.module.css'

import {
  isLoadingEditorial,
  getEditorialData,
} from '../../shared/state/editorial/selectors'

class About extends Component {
  galleryImages() {
    const { editorialData: { galleryImages = [] } = {} } = this.props

    return galleryImages.map(({ url }) => ({ original: url, thumbnail: url }))
  }

  render() {
    const {
      editorialData: {
        companyLongDescription,
        galleryImages = [],
        aboutHeaderImage: { url: photoUrl } = {},
      } = {},
    } = this.props

    return (
      <div className={styles.main}>
        <div className={styles.aboutHeader}>
          <img src={photoUrl} />
        </div>
        <div className={styles.aboutWrapper}>
          <SectionTitle title={'Sobre Nós'} center={false} />

          <div className={styles.aboutLongDescription}>
            <Markdown source={companyLongDescription} />
          </div>

          {galleryImages.length ? (
            <div className={styles.aboutGallery}>
              <SectionTitle title={'Galeria de Imagens'} center={false} />

              <ImageGallery
                additionalClass={styles.imageGallerySlide}
                showPlayButton={false}
                autoPlay={true}
                showIndex={true}
                slideInterval={10000}
                items={this.galleryImages()}
              />
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return state => ({
    isLoadingEditorial: isLoadingEditorial(state),
    editorialData: getEditorialData(state),
  })
}

export default connect(mapStateToProps)(About)
